import { createContext, useContext, useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";
import { authenticate } from "../API/swesum";

const AuthContext = createContext();

export const AuthProvider = ({ storedAuthData, children }) => {
  const [authData, setAuthData] = useLocalStorage("authData", storedAuthData);

  const login = async (authData, callback) => {
    setAuthData(authData);
    if (callback) callback();
    //navigate("/users", { replace: true });
  };

  const logout = async (callback) => {
    setAuthData();
    if (callback) callback();
    //navigate("/login", { replace: true });
  };

  const isAdmin = useMemo(() => {
    return authData?.userType === "admin";
  }, [authData?.userType]);

  const value = useMemo(
    () => ({
      authData,
      isAdmin,
      login,
      logout,
    }),
    [authData]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
